module.exports = __webpack_public_path__ + "media/images/new_home/menu-0b58a3efc158fb47ac93db4fb6a4527a.svg";